import { useMemo } from 'react'

import { getIsRichTextEmpty } from 'src/components/form/util'
import RenderedRichTextInput from 'src/components/RenderedRichTextInput/RenderedRichTextInput'

import HStack from '../Flex/HStack'
import QuickTip from '../QuickTip/QuickTip'
import { T } from '../Text/Text'

type Props = {
  className?: string
  id: string | undefined
  isLabelRedundant: boolean | undefined
  isRequired: boolean | undefined
  label: React.ReactNode
  hideRequiredAsterisk?: boolean
  tooltip: string | null | undefined
}
const FormControlLabel = ({
  className,
  id,
  isLabelRedundant,
  isRequired,
  label,
  hideRequiredAsterisk,
  tooltip,
}: Props) => {
  const renderRequiredAsterisk = hideRequiredAsterisk ? false : isRequired
  const labelContent = useMemo(
    () => (
      <HStack gap={1} align="baseline" width="100%">
        {typeof label === 'string' ? (
          <T.Label as="span">
            {label}
            {renderRequiredAsterisk && (
              <T.Label as="span" className="text-red-700">
                &nbsp;*
              </T.Label>
            )}
          </T.Label>
        ) : (
          <>
            {label}
            {renderRequiredAsterisk && (
              <T.Label as="span" className="shrink-0 text-red-700">
                &nbsp;*
              </T.Label>
            )}
          </>
        )}
        {!getIsRichTextEmpty(tooltip) && (
          <QuickTip
            content={<RenderedRichTextInput>{tooltip}</RenderedRichTextInput>}
            // Rich-text tooltips can contain links, so keep them click-controlled for accessibility.
            trigger="click"
          />
        )}
      </HStack>
    ),

    [label, renderRequiredAsterisk, tooltip]
  )

  if (isLabelRedundant) {
    // Avoids "Multiple form labels" accessibility error
    return labelContent
  }

  return (
    <label htmlFor={id} className={className}>
      {labelContent}
    </label>
  )
}

export default React.memo(FormControlLabel)
